import { emptyString, emptyArray } from "constants/emptyConst";
import verificationStatusIds from "constants/verificationStatusIds";

export const getPagingLimits = pager => {
  const { page, pageSize } = pager;

  const indexOfLastItem = page * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;

  return { indexOfFirstItem, indexOfLastItem };
};

export const filterManualVerificationsByValue = (verifications, filter) => {
  return verifications.filter(o =>
    Object.keys(o).some(k => {
      if (o[k] !== null && (k === "verificationType" || k === "partnerName"))
        return o[k].toString().toLowerCase().includes(filter.toString().toLowerCase());
      return null;
    })
  );
};

export const filterByValue = (verifications, filter) => {
  return verifications.filter(o =>
    Object.keys(o).some(k => {
      if (o[k] !== null && (k === "comments" || k === "verificationType" || k === "partnerName"))
        return o[k].toString().toLowerCase().includes(filter.toString().toLowerCase());
      return null;
    })
  );
};

export const getVerificationDocumentDetails = verification => {
  if (verification.documentTypeId) return `/ ${verification.documentTypeName} ${verification.documentNumber}`;

  return emptyString;
};

export const disableDownload = (item, rights) => item.sensitiveInfo && !rights.clientSensitiveInfoRead;

export const addExistingItemToVerificationList = (list, item) => {
  list.push(item);
  return list;
};

export const removeExistingItemFromVerificationList = (list, item) =>
  list.filter(i => i.verificationTypeId !== item.verificationTypeId);

export const filterVerificationTypes = (verificationTypes, selectedEntity, allVerifications) => {
  if (!selectedEntity) return verificationTypes;
  const inProcessVerificationsIds = allVerifications
    ?.filter(x => x.statusId === verificationStatusIds.InProcess)
    .map(x => x.verificationTypeId);

  let entityVerifications = verificationTypes?.filter(v => v.entityType === selectedEntity?.type);
  entityVerifications = entityVerifications?.filter(v => !inProcessVerificationsIds.includes(v.verificationTypeId));

  return entityVerifications;
};

export const getVerificationsStatus = (verificationsToEdit, verificationsToAdd) => {
  if (!verificationsToEdit || !verificationsToAdd || !verificationsToAdd.length) return { status: false, value: 0 };

  const manualVerifications = JSON.parse(JSON.stringify(emptyArray));

  verificationsToAdd.forEach(vt => {
    vt.manualVerifications?.forEach(mv => manualVerifications.push(mv));
  });

  const totalLength = manualVerifications.reduce((cv, acc) => cv + acc.verificationData?.length, 0);

  return { status: totalLength > 0, value: totalLength };
};
